import {
  PIN_COMMENT_SUCCESS,
  UNPIN_COMMENT_SUCCESS
} from '../actions/comments'

export default function (state = {}, action) {
  switch (action.type) {
    case PIN_COMMENT_SUCCESS:
      var id = action.payload.commentId.replace(/\D/g, '')

      return {
        ...state,
        [id]: {
          ...state[id],
          pinned: true
        }
      }

    case UNPIN_COMMENT_SUCCESS:
      id = action.payload.commentId.replace(/\D/g, '')

      return {
        ...state,
        [id]: {
          ...state[id],
          pinned: false
        }
      }
  }

  return state
}



// WEBPACK FOOTER //
// ./src/reducers/comments.js